export enum ContentType {
	NOTION = 'NOTION',
	MIRO = 'MIRO',
	HTML = 'HTML',
}
